<template>
    <div class="home-all header-90">
      <div class="home-main">
        <!-- Swiper -->
        <div class="swiper-container home_banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide"  v-for="(item,index) in bannerData" :key="index">
              <a :href="item.url">
                <img class="mobile_hide" :src="item.image" alt="" width="100%">
                <img class="pc_hide" :src="item.phoneImage" alt="" width="100%">
              </a>
            </div>
          </div>
          <a href="#001" class="scrollTop"><div data-v-84399ace="" class="scroll-img"></div></a>
          <!-- Add Arrows -->
          <div class="swiper-pagination pc_hide home-banner-swiper-pagination" ></div>
          <div class="swiper-button-next swiper-button-next1"></div>
          <div class="swiper-button-prev swiper-button-prev1"></div>
        </div>
        <div class="home-conten ">
          <div class="title all-lr5 scrollTop" id="001">
            <h2>Persistence</h2>
            <p class="subtitle">
              <span class="line"></span>
              <span class="subtitle-font" :class="{'en-font-36':locale=='EN'}">{{$t("home_8")}}</span>
            </p>
          </div>
          <div class="home-box">
            <!-- Swiper -->
            <div class="mobile_hide">
              <home-banner class="home-conten4"></home-banner>
            </div>

            <!--Swiper-->
            <div class="bg-color">
              <div class="">
                <div class="swiper-container home-conten3">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in poductImgData" :key="index">
                      <router-link :to="'/Product/' + item.id">
                        <div class="img-box">
                          <img :src="item.image" alt="" class="mobile_hide">
                          <img :src="item.circleImage" alt="" class="pc_hide">
                          <div class="name-box">
                            <span class="name">{{ item.name }}</span>
                            <span class="name-en" v-if="item.name != item.nameEN">{{ item.nameEN }}</span>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <!-- Add Arrows -->
                  <div class="swiper-button-next swiper-button-next2"></div>
                  <div class="swiper-button-prev swiper-button-prev2"></div>
                  <div class="swiper-pagination home-banner-pagination pc_hide" id="swiper-pagination"></div>
                </div>
              </div>
            </div>

            <div class="home-search">
              <div class="title text-C ">
                <h2>Store Information</h2>
                <p class="subtitle">
                  <span class="line"></span>
                  <span class="subtitle-font">{{$t("home_11")}}</span>
                </p>
                <p class="pb-57 subtitle2">{{$t("home_12")}}</p>
              </div>
              <div class="search-conten">
                <div class="w-100">
                  <input type="text" v-model="searchValue" :placeholder="$t('home_13')" >
                  <span class="icon" @click="toSearch()"></span>
                </div>
                <div class="w-50">
                  <div class="select-1">
                    <vue-select2 :cityValue="cityValue" type="city"  :tip="$t('store_2')"  :list="cityData" @valueChanged="getSelectValue"></vue-select2>
                  </div>
                  <div class="select-2">
                    <vue-select2 :cityValue="areaValue" type="area" :tip="$t('store_3')" :list="areaData" @valueChanged="getSelectValue"></vue-select2>
                  </div>


                </div>

                <div class="moreSearch-conten">
                  <div class="moreSearch" @click="toSearch()">
                    <div class="more" ><router-link :to="'/store'">{{$t('home_5_2')}}</router-link></div>
                  </div>
                  <div class="btn">
                    <button @click="toSearch()">{{$t('home_15')}}<span></span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-video ">
              <div class="vegetablesBg video-3">
              <img src="../assets/images/vegetables.png" alt="">
              </div>
              <div class="title  video-7">
               <h2>Blessed  </h2>
               <span class="line mobile_hide"></span>
               <p class="subtitle">
                 <span class="line pc_hide"></span>
                 <span class="subtitle-font">{{$t('home_16')}}</span>
               </p>
             </div>
              <div class="video-box ">
                <div class="left" v-if="videoData[0]">
                    <iframe width="560" height="315" id="myframe" :src="videoData[0].path" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="right">
                  <div class="swiper-container swiperOne" :class="{ 'swiper-box': isPc, 'swiper-containerOne': !isPc }">
                    <div class="swiperOne-wrapper" :class="{'swiper-wrapper-box':isPc,'swiper-wrapper':!isPc}">
                      <div class="swiper-slide" :class="{active:videoType == 0}"   @click="changeVideo(0)">
                        <div class="lineYellow"></div>
                        <div class="video-image">
                          <img src="../assets/images/videoIcon01.svg" alt="">
                        </div>
                        <div class="video-text" >
                          <h4>{{$t('home_17')}}</h4>
                          <p>{{$t('home_18')}}</p>
                        </div>

                      </div>
                      <div class="swiper-slide" :class="{active:videoType == 1}" @click="changeVideo(1)">
                        <div class="lineYellow"></div>
                        <div  class="video-image">
                          <img src="../assets/images/videoIcon02.svg" alt="">
                        </div>
                        <div  class="video-text">
                          <h4>{{$t('home_19')}}</h4>
                          <p>{{$t('home_20')}}</p>
                        </div>
                      </div>
                      <div class="swiper-slide" :class="{active:videoType == 2}"  @click="changeVideo(2)">
                        <div class="lineYellow"></div>
                        <div  class="video-image">
                          <img src="../assets/images/videoIcon03.svg" alt="">
                        </div>
                        <div  class="video-text">
                          <h4>{{$t('home_21')}}</h4>
                          <p>{{$t('home_22')}}</p>
                        </div>
                      </div>

                    </div>
                    <div class="swiper-button-next swiper-button-next3 pc_hide"></div>
                    <div class="swiper-button-prev swiper-button-prev3 pc_hide"></div>
                  </div>
                </div>
             </div>

          </div>
          <div class="home-product">
            <div>
              <div class="home-left">
                <img src="../assets/images/dumplings.png" alt="">
              </div>
              <div class="home-right">
                <img src="../assets/images/surface.png" alt="">
              </div>
              <div class="home-centen title title-white title-line-h2">
                <div class="title-line">
                  <h2>Safety</h2>
                  <span class="line"></span>
                </div>
                <p class="subtitle"><span class="subtitle-font" :class="{'en-subtitle-font':locale=='EN'}">{{$t('home_23')}}</span></p>
                <p class="font-18" >{{$t('home_24')}}</p>
                <div class="moreLink">
                  <a href="/AboutUs/top2" class="more">{{$t('home_29')}}</a>
                </div>
              </div>
            </div>
            <div class="home-safe-box all-lr5">
              <ul>
                <li>
                  <div class="imageBig"  @click="linkAboutUs('top2')">
                    <img src="../assets/images/food-policy01.png" width="100%" alt="" v-if="this.$i18n.locale === 'tw'">
                    <img src="../assets/images/food-policy012.png" alt="" width="100%" v-if="this.$i18n.locale === 'cn'">
                    <img src="../assets/images/food-policy013.png" alt="" width="100%" v-if="this.$i18n.locale === 'jpa'">
                    <img src="../assets/images/food-policy014.png" alt="" width="100%" v-if="this.$i18n.locale === 'en'">
                  </div>

                </li>
                <li>
                  <div class="imageBig" @click="linkAboutUs('top2')">
                    <img src="../assets/images/food-policy02.png" width="100%" alt="" v-if="this.$i18n.locale === 'tw'">
                    <img src="../assets/images/food-policy022.png" alt="" width="100%" v-if="this.$i18n.locale === 'cn'">
                    <img src="../assets/images/food-policy023.png" alt="" width="100%" v-if="this.$i18n.locale === 'jpa'">
                    <img src="../assets/images/food-policy024.png" alt="" width="100%" v-if="this.$i18n.locale === 'en'">
                  </div>

                </li>
                <li>
                  <div class="imageBig aa" @click="linkAboutUs('top3')">
                    <img src="../assets/images/food-policy03.png" width="100%" alt="" v-if="this.$i18n.locale === 'tw'">
                    <img src="../assets/images/food-policy032.png" alt="" width="100%" v-if="this.$i18n.locale === 'cn'">
                    <img src="../assets/images/food-policy033.png" alt="" width="100%" v-if="this.$i18n.locale === 'jpa'">
                    <img src="../assets/images/food-policy034.png" alt="" width="100%" v-if="this.$i18n.locale === 'en'">
                  </div>

                </li>
              </ul>
            </div>
          </div>
          <div class="pc_hide newsFoot"  v-if="footData.footNewMessages">
            <h5>{{$t("home_3")}} <span class="line"></span></h5>
            <div class="dotted-box dotted-147">
              <div v-for="(item,index) in footData.footNewMessages.footNewMessagesListDto"  :key="index">
                <router-link  :to="'/newsDetails/'+item.id">
                   <div class="dotted-line">
                     <span>{{item.date}}</span>
                     <a >{{item.typeName}}</a>
                   </div>
                   <p>{{item.title}}</p>
                </router-link>
              </div>
              <div>
                <router-link  to="/news" class="more">{{$t("home_29")}}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import API from "./config/api.js";
import HomeBanner from "../components/default/home-banner";
import Popup from "./default/Popup";
import VueSelect2 from './default/vue-select2'
import logo from '@/assets/images/logo.svg'
import restaurant from '@/assets/images/about047.png'
import organization from '@/assets/images/about046.png'
export default {
  name: 'Home',
  inject:['reload'],
  metaInfo() {
    return {
      title: '八方雲集安心餐點｜現煎鍋貼、水餃、牛肉麵與冷凍商品',
      meta: [
        //  SEO 用（搜尋引擎）
      {
        name: "description",
        content: '八方雲集以「安心餐點」為理念，嚴選契作食材與專業製程，提供現煎鍋貼、水餃、牛肉麵與冷凍商品。從食材堅持到食安管理，結合幸福企業精神，讓美味與安心在八方匯聚'
      },

        // Open Graph
        { property: 'og:title', content: '八方雲集 - 台灣鍋貼水餃第一品牌' },
        { property: 'og:description', content: '八方雲集提供新鮮美味的鍋貼、水餃及各式麵食,嚴選食材、用心製作,全台門市據點眾多,歡迎您前來品嚐。' },
        { property: 'og:image', content: 'https://www.8way.com.tw/assets/images/ogImg_home.jpg' },
        { property: 'og:url', content: 'https://www.8way.com.tw/' },
        { property: 'og:type', content: 'website' }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": "https://www.8way.com.tw/#website",
            "url": "https://www.8way.com.tw/",
            "name": "八方雲集",
            "description": "八方雲集官方網站－堅持新鮮食材當天製作，當天運送，提供美味鍋貼、水餃、麵食、湯品及小菜",
            "inLanguage": "zh-TW",
            "publisher": {
              "@id": "https://www.8way.com.tw/#organization"
            },
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://www.8way.com.tw/store?searchValue={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }
        },
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.8way.com.tw/#organization",
            "name": "八方雲集",
            "alternateName": "BaFang Yunji",
            "legalName": "八方雲集國際股份有限公司",
            "url": "https://www.8way.com.tw/",
            "logo": {
              "@type": "ImageObject",
              "url": this.logoImage,
              "@id": "https://www.8way.com.tw/#logo"
            },
            "image": this.organizationImage,
            "description": "台灣知名連鎖餐飲品牌，專營鍋貼、水餃、麵食、湯品及中式餐點。",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "淡水區中正東路二段27號18樓",
              "addressLocality": "新北市",
              "postalCode": "251",
              "addressCountry": "TW"
            },
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "0800-898-000",
                "contactType": "customer service",
                "availableLanguage": ["zh-TW", "en"],
                "areaServed": "TW"
              }
            ],
            "sameAs": [
              "https://www.facebook.com/8wayTW/",
              "https://www.instagram.com/bafangtw/"
            ],
            "founder": {
              "@type": "Person",
              "name": "林家鈺"
            }
          }
        },
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "Brand",
            "@id": "https://www.8way.com.tw/#brand",
            "name": "八方雲集",
            "url": "https://www.8way.com.tw/",
            "logo": {
              "@type": "ImageObject",
              "url": this.logoImage,
              "@id": "https://www.8way.com.tw/#logo"
            },
            "description": "八方雲集為台灣人氣連鎖餐飲品牌,以鍋貼、水餃等中式料理聞名,致力提供新鮮、美味、安心的餐點體驗。",
            "image": this.restaurantImage
          }
        },
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://www.8way.com.tw/#localbusiness",
            "name": "八方雲集國際股份有限公司",
            "image": this.organizationImage,
            "url": "https://www.8way.com.tw/",
            "telephone": "0800-898-000",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "淡水區中正東路二段27號18樓",
              "addressLocality": "新北市",
              "postalCode": "251",
              "addressCountry": "TW"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.1696,
              "longitude": 121.4434
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          }
        },
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首頁",
                "item": "https://www.8way.com.tw/"
              }
            ]
          }
        },
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "鍋貼系列",
                "url": "https://www.8way.com.tw/Product/0201"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "水餃系列",
                "url": "https://www.8way.com.tw/Product/0202"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "湯麵系列",
                "url": "https://www.8way.com.tw/Product/0205"
              },
              {
                "@type": "ListItem",
                "position": 4,
                "name": "湯品系列",
                "url": "https://www.8way.com.tw/Product/0206"
              }
            ]
          }
        }
      ]
    }
  },
  data () {
    return {
      logoImage: logo,
      restaurantImage: restaurant,
      organizationImage: organization,
      isPc: true,
      bannerData:{},
      poductImgData:{},
      videoData:[],
      cityData:[],
      areaData:[],
      cityValue: '',
      areaValue: '',
      isShowCity: false,
      isShowArea: false,
      searchValue: '',
      videoType:0,
      footData:{},
      vals:'',
      locale:'tw'
    }
  },
  mounted(){
    this.locale=sessionStorage.getItem('lang')
    //判断是否为pc端
    if (document.body.clientWidth <= 1080){
      this.isPc = false;
    }else{
      this.isPc = true;
    }
    let self = this;
    /*手机端视频内容切换*/
    setTimeout(function(){
      var mySwiper = new Swiper('.swiper-containerOne',{
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next3',
          prevEl: '.swiper-button-prev3',
        },
        on: {
          slideChangeTransitionStart: function(){
            self.changeVideo(this.activeIndex);
          }
        }
      })
    },500)
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
      if(this.screenWidth <= 768){
        this.isPc = false;
      }else{
        this.isPc = true;
      }
    };
    this.GetHomeBanner();
    this.GetProductImg();
    this.GetVideo();
    this.GetCity();
    this.GetFootList();

    //scroll top
    $('.scrollTop').click(function(e) {
      e.preventDefault();
      var target = $(this).attr('href');
      var targetPos = $(target).offset().top - 100;
      $('html, body').animate({ scrollTop: targetPos }, 1000);
    });
  },
  methods:{
    linkAboutUs(id){
      this.$router.push({path: '/AboutUs/' + id});
    },
    valueChanged(val){
      console.log(val)
    },
    GetHomeBanner:function(){
      this.$fetch(API.GetWebHomeBannerList).then((response) => {
        if(response.code == 200){
          this.bannerData = response.data;
          //启动banner
          this.$nextTick(()=>{
            setTimeout(()=>{
              var swiper = new Swiper('.home_banner', {
                navigation: {
                  nextEl: '.swiper-button-next1',
                  prevEl: '.swiper-button-prev1',
                },
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: '.home-banner-swiper-pagination',
                  clickable: true,
                },
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
              });
            },500)
          })
        }
      });
    },
    GetProductImg:function(){
      this.$fetch(API.GetWebHomeProductCategoryList).then((response) => {
        if(response.code == 200){
          this.poductImgData = response.data;
          //启动图片
          let self = this;
          this.$nextTick(()=>{
            setTimeout(()=>{
              var swiper2 = new Swiper('.home-conten3', {
                slidesPerView: "auto",
                spaceBetween: 0,
                initialSlide: self.poductImgData.length - 3,
                loop: true,
                breakpoints: {
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    initialSlide: self.poductImgData.length - 1,
                  },
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    initialSlide: self.poductImgData.length - 1,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    initialSlide: self.poductImgData.length - 2,
                  },
                  1080: {
                    slidesPerView: "auto",
                  }
                },
                navigation: {
                  nextEl: '.swiper-button-next2',
                  prevEl: '.swiper-button-prev2',
                },
                pagination: {
                  el: '.home-banner-pagination',
                  clickable: true,
                },
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
              });
            },500)
          })
        }
      });
    },
    GetVideo:function(){
      this.$fetch(API.GetWebHomeVideoIntroduction).then((response) => {
        if(response.code == 200){
          this.videoData = response.data;
        }
      });
    },

    /*搜索*/
    GetCity:function(){
      this.$fetch(API.GetCityList).then((response) => {
          if(response.code == 200){
            this.cityData = response.data;
            if(response.data){
              this.GetArea(response.data[0]);
            }
          }
      });
    },
    GetArea:function(val){
      this.$post(API.GetAreaList+val).then((response) => {
        if(response.code == 200){
          this.areaData = response.data;
        }
      });
    },
    getSelectValue(value){
      if(value.type == 'city'){
        this.cityValue = value.currentValue;
        this.areaValue = '';
        this.GetArea(this.cityValue);
      }else if(value.type == 'area'){
        this.areaValue = value.currentValue;
      }
    },
    GetFootList:function(){
      this.$fetch(API.GetWebFootList).then((response) => {
        if(response.code == 200){
          this.footData = response.data;
        }
      });
    },
    toSearch(){
      this.$router.push({path: '/store', query: {
        searchValue: this.searchValue,
        cityValue: this.cityValue,
        areaValue: this.areaValue
      }});
    },
    changeVideo(value){
      console.log(value)
      this.videoType = value;
      $('#myframe').attr('src', this.videoData[value].path);
    }
  },
  components:{
    'home-banner': HomeBanner,
    'vue-select2': VueSelect2
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>




// WEBPACK FOOTER //
// src/components/home.vue